import React from 'react';

import { ConditionProps } from './types';

const Condition = ({ condition, children, fallback }: ConditionProps) => {
  return condition ? <>{children}</> : fallback ? <>{fallback}</> : null;
};

export default Condition;
